export const careSupportEmail = "CxECareDataStrategy@microsoft.com";
export const reportRequestFormLink = "https://aka.ms/CxECareDataStrategyRequest";
